module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card c-card--claim-forms"
  }) : _c('div', {
    staticClass: "c-card c-card--claim-forms"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('i', {
    staticClass: "c-card__header__icon fa fa-inbox t-headline"
  })]), _vm._v(" "), (_vm.card.description) ? _c('div', {
    staticClass: "c-card--claim-forms__description"
  }, [_c('p', [_vm._v(_vm._s(_vm.card.description))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.openedForm === null) ? _c('form-list', {
    attrs: {
      "title": _vm.card.title,
      "forms": _vm.formDetails,
      "submitted-form": _vm.submittedForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openedForm !== null) ? _c('form-detail', {
    attrs: {
      "forms": _vm.formDetails,
      "form-index": _vm.openedForm
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a73e6350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/ClaimForms.vue
// module id = 561
// module chunks = 1